import clsx from 'clsx';
import { useSnackbar } from 'notistack';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSetRecoilState } from 'recoil';
import { PrivilegeService } from 'api';
import { getPendingPrivilegesRequestId } from 'api/privileges/getCustomerPendingPrivileges';
import { SecondaryButton } from 'components/Button';
import dateTimeFormatter from 'utils/date/dateTimeFormatter';
import useStyles from './AccessStyles';
export default function PendingPrivilegeRow({
  pendingPrivilege
}) {
  const {
    pendingPrivilege: pendingPrivilegeClass,
    column,
    emailColumn,
    conditionalColumn
  } = useStyles();
  const {
    enqueueSnackbar
  } = useSnackbar();
  const [loading, setLoading] = useState();
  const {
    t
  } = useTranslation();
  const setPendingPrivilegeRequestId = useSetRecoilState(getPendingPrivilegesRequestId);
  const deactivateToken = async () => {
    setLoading(true);
    try {
      await PrivilegeService.deactivateGrantAccessToken({
        pendingPrivilegeId: pendingPrivilege.id
      });
      enqueueSnackbar(t('access_management.token_deactivated'), {
        variant: 'success'
      });
    } catch {
      enqueueSnackbar(t('access_management.failed_deactivating_token'), {
        variant: 'error'
      });
    }
    setPendingPrivilegeRequestId(id => id + 1);
  };
  return /*#__PURE__*/React.createElement("div", {
    className: pendingPrivilegeClass
  }, /*#__PURE__*/React.createElement("div", {
    className: clsx(column, emailColumn)
  }, pendingPrivilege.receiverEmail), /*#__PURE__*/React.createElement("div", {
    className: clsx(column, conditionalColumn)
  }, dateTimeFormatter(pendingPrivilege.createdOn)), /*#__PURE__*/React.createElement("div", {
    className: clsx(column, conditionalColumn)
  }, dateTimeFormatter(pendingPrivilege.validUntil)), /*#__PURE__*/React.createElement("div", {
    className: column
  }, /*#__PURE__*/React.createElement(SecondaryButton, {
    ariaLabel: "deactivate-token",
    onClick: deactivateToken,
    outlined: true,
    loading: loading
  }, t('access_management.deactivate_token'))));
}